import api from '../../../config/axios-interceptor';

/* ---------------------------------------------
 * 1) Fetch Notifications (with filters & paging)
 * --------------------------------------------- */
export const fetchNotifications = async (page = 0, pageSize = 10, filters = {}) => {
    try {
        const params = new URLSearchParams();
        params.append("page", page.toString());
        params.append("size", pageSize.toString());
        params.append("sort", "createdAt,desc");

        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, value);
            }
        });

        return await api.get(`/api/v1/notification/find-all?${params.toString()}`);
    } catch (error) {
        console.error("❌ Error fetching notifications:", error);
        throw error;
    }
};

/* -------------------------------
 * 2) Fetch Notification By ID
 * ------------------------------- */
export const fetchNotificationById = async (id) => {
    try {
        return await api.get(`/api/v1/notification/find/${id}`);
    } catch (error) {
        console.error("❌ Error fetching notification by ID:", error);
        throw error;
    }
};

/* -------------------------------
 * 3) Mark Notification As Read
 * ------------------------------- */
export const markNotificationAsRead = async (id) => {
    try {
        return await api.put(`/api/v1/notification/mark-as-read/${id}`);
    } catch (error) {
        console.error("❌ Error marking notification as read:", error);
        throw error;
    }
};

/* -------------------------------------
 * 4) Bulk Mark All Notifications As Read
 * ------------------------------------- */
export const bulkMarkNotificationsAsRead = async () => {
    try {
        return await api.put(`/api/v1/notification/mark-as-read/bulk`);
    } catch (error) {
        console.error("❌ Error bulk marking notifications as read:", error);
        throw error;
    }
};

/* -------------------------------
 * 5) Delete Notification
 * ------------------------------- */
export const deleteNotification = async (id) => {
    try {
        return await api.delete(`/api/v1/notification/delete/${id}`);
    } catch (error) {
        console.error("❌ Error deleting notification:", error);
        throw error;
    }
};
